module.exports = __webpack_public_path__ + "media/images/flags/1x1/dom-ac142568f0f3e21d6e152bdd2ff12bbf.svg";